import { Bad, Ok } from "@leavy/result";
import { StepCommand } from "@leavy/lv-onboarding-srv/lib/common/command/StepCommand";
import { Equals, IsUUID } from "@leavy/validator";
import { OnboardingId } from "@leavy/lv-onboarding-srv/lib/common/domain/OnboardingId";
import { RpcInvocable } from "@leavy/cq-core";
import { HOMESHARING_BACKEND_SERVICE_NAME } from "../../../base";
import { CommonEditOnboardingError } from "../../ForwardedOnboardingCommand";

export type DeleteInventorySubjectLocalCommandResult =
    | Ok
    | Bad<"SUBJECT_NOT_FOUND">
    | CommonEditOnboardingError;

@RpcInvocable({
    namespace: HOMESHARING_BACKEND_SERVICE_NAME,
    alias: "delete_inventory_subject",
})
export class DeleteInventorySubjectLocalCommand extends StepCommand<DeleteInventorySubjectLocalCommandResult> {
    @Equals(OnboardingId.HL)
    onboardingId: OnboardingId.HL = OnboardingId.HL;

    @IsUUID("4")
    subjectId!: string;
}
